import { Grid, Typography } from '@mui/material';
import { useCustomStyles } from '../../../../style/global';
import { LoadingButton } from '@mui/lab';
import React, { useMemo, useState } from 'react';
import InputFilled from '../../../UI/Input/InputFilled';
import { fnLocalizeFilter } from '../../../../services/localize.service';
import classNames from 'classnames';
import { useStyles } from '../style';
import { useGlobalContext } from '../../../../services/context.service';
import { authAPI } from '../../../../services/authAPI.service';
import { styled } from '@mui/material/styles';
import { TShowTypeForm } from '../Auth';
import InputPhone from '../../../UI/Input/InputPhone';
import { showTooltip } from '../../../../store/actions/layoutActions';
import { useAppDispatch } from '../../../../hooks/redux';

interface ILogin {
  handleRegisterOrForgot(type: TShowTypeForm): void;
}

const LinkRegister = styled(Typography)(() => ({
  margin: '.5rem', fontSize: '12px',
}));

export default function Login({ handleRegisterOrForgot }: ILogin) {

  const classes = useStyles();
  const global = useCustomStyles();
  const { locale, config } = useGlobalContext();

  const [login, setLogin] = useState<string>('');
  const [pass, setPass] = useState<string>('');
  const [userAuth, { isLoading }] = authAPI.useLazyUserAuthQuery();

  /* Управление состоянием */
  const dispatch = useAppDispatch();

  const handleChangeLogin = (type: 'text' | 'phone' | 'email', e: any) => {
    let value = '';
    switch (type) {
      case 'email':
      case 'text': {
        value = e.currentTarget.value;
        break;
      }
      case 'phone': {
        value = e.target.value;
        break;
      }
    }
    setLogin(value);
  };

  const handleChangePass = (e: any) => {
    setPass(e.currentTarget.value);
  };

  const handleUserAuth = async () => {
    if (login === '' || pass === '') {
      dispatch(showTooltip({ type: 'info', message: fnLocalizeFilter(locale, '_lang.error.1100') }));
    } else {
      await userAuth({ username: login, password: pass });
    }
  };

  const handleBtn = (e: any) => {
    handleRegisterOrForgot(e.target.id);
  };

  const renderEnterTitle = useMemo(() => {
    let str = fnLocalizeFilter(locale, '_lang.module.login.enterCRM');

    if (config?.locale?.auth?.enterCRM) {
      str = config.locale.auth.enterCRM;
    }

    return str;
  }, [locale, config]);

  const renderAuthTypeInput = useMemo(() => {
    switch (config.loginFormat) {
      case 1: // - телефон
        return (<InputPhone
          sx={{ width: '97%' }}
          inputType={'filled'}
          value={login}
          onChange={handleChangeLogin.bind(null, 'phone')}
          label={fnLocalizeFilter(locale, '_lang.module.login.titleLogin')}
        />);
      default: // - текст
        return (<InputFilled label={fnLocalizeFilter(locale, '_lang.module.login.titleLogin')} id={'login'}
                             onChange={handleChangeLogin.bind(null, 'text')} value={login} />);
    }

  }, [config.loginFormat, locale, login]);

  return <>
    <Grid sx={{ marginTop: 'auto' }}>
      <Grid item className={global.titleBold}
            style={{
              margin: '0 auto 1vw 0', fontSize: '30px', fontWeight: 700,
            }}>  {renderEnterTitle}</Grid>
      <Grid item
            className={global.textDefault}> {fnLocalizeFilter(locale, '_lang.module.login.welcomeText')}</Grid>


      {renderAuthTypeInput}

      <InputFilled label={fnLocalizeFilter(locale, '_lang.module.login.titlePassword')} id={'pass'}
                   onChange={handleChangePass} type={'password'} value={pass} />
      <LoadingButton
        variant='contained'
        loading={isLoading}
        style={{
          width: '100%', marginTop: '.7rem', padding: '.7rem 0',
        }}
        onClick={handleUserAuth}
      >
        {fnLocalizeFilter(locale, '_lang.module.login.btnEnter')}
      </LoadingButton>
      <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LinkRegister className={classNames(global.textDefault, classes.btnRegister)} id={'register'}
                      onClick={handleBtn}
        >{fnLocalizeFilter(locale, '_lang.module.login.btnRegister')}</LinkRegister> /
        <LinkRegister className={classNames(global.textDefault, classes.btnRegister)} id={'forgotPass'}
                      onClick={handleBtn}
        >{fnLocalizeFilter(locale, '_lang.module.login.btnForgotPass')}</LinkRegister>

      </Grid>
    </Grid>
  </>;
}
